<label *ngIf="label" [for]="for" class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
  {{ label | translate }} <span *ngIf="required">*</span>
</label>
